// src/lib/download.js
import { http } from './api';

export async function descargarPdfOrden(id, numero) {
  try {
    console.log(`Descargando PDF para orden ID: ${id}, número: ${numero}`);
    
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error('No se encontró token de autenticación');
    }

    const res = await http.get(`/ordenes/${id}/pdf`, { 
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${token}`,
        'Accept': 'application/pdf'
      },
      timeout: 30000 // 30 segundos timeout
    });
    
    console.log('Respuesta del servidor:', res);
    console.log('Content-Type:', res.headers['content-type']);
    
    // Verificar que la respuesta sea un PDF o contenga datos
    const contentType = res.headers['content-type'] || res.headers['Content-Type'];
    if (!contentType || (!contentType.includes('application/pdf') && !contentType.includes('application/octet-stream'))) {
      console.warn('Content-Type inesperado:', contentType);
      // No lanzar error aquí, intentar descargar de todas formas
    }

    // Verificar que hay datos
    if (!res.data || res.data.size === 0) {
      throw new Error('El archivo PDF está vacío');
    }

    const blob = new Blob([res.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `orden_${numero || id}.pdf`;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    
    // Limpiar el URL después de un tiempo
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 30000);
    
    console.log('PDF descargado exitosamente');
    
  } catch (err) {
    console.error('Error al descargar PDF:', err);
    
    // Mensajes de error más específicos
    let mensaje = 'No se pudo descargar el PDF.';
    if (err.code === 'ECONNABORTED' || err.message.includes('timeout')) {
      mensaje = 'Tiempo de espera agotado. El servidor tardó demasiado en responder.';
    } else if (err.response?.status === 404) {
      mensaje = 'La orden no fue encontrada en el servidor.';
    } else if (err.response?.status === 403) {
      mensaje = 'No tiene permisos para descargar esta orden.';
    } else if (err.response?.status >= 500) {
      mensaje = 'Error interno del servidor. Intente nuevamente en unos minutos.';
    } else if (err.message.includes('token')) {
      mensaje = 'Sesión expirada. Por favor, inicie sesión nuevamente.';
    }
    
    alert(`${mensaje}\n\nDetalles técnicos: ${err.message}`);
    throw err; // Re-lanzar para que el componente pueda manejarlo
  }
}
